import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { type ProfileType, VerticalType } from '@rma/generic/domain/types';
import { MapMarkerType, MapRequest, SALES_HISTORY_FROM } from '@rma/generic/maps/domain';
import { PossessivePipe } from '@rma/public/generic/util/pipes/possesive';
import { InlineMapComponent } from '@rma/public/maps/public/orc-inline-map';

@Component({
  selector: 'rma-profile-map-inline',
  imports: [InlineMapComponent, PossessivePipe, TranslocoModule],
  templateUrl: './profile-map-inline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('profileMapCta')],
})
export class ProfileMapInlineComponent implements OnChanges {
  @Input({ required: true })
  verticalType!: VerticalType;

  @Input({ required: true })
  profileType!: ProfileType;

  @Input({ required: true })
  profileCode!: string;

  @Input({ required: true })
  mapType!: MapMarkerType;

  @Input()
  public name!: string;

  @Input()
  canHaveProperties!: boolean;

  protected mapRequest!: MapRequest;
  protected mapTypes: MapMarkerType[] = ['Review', 'CompletedListing', 'ActiveListing'];

  ngOnChanges(changes: SimpleChanges): void {
    const { verticalType, profileType, profileCode, mapType, canHaveProperties } = changes;

    if (
      (verticalType || profileType || profileCode || mapType) &&
      this.verticalType &&
      this.profileType &&
      this.profileCode &&
      this.mapType
    ) {
      this.mapRequest = {
        verticalType: this.verticalType,
        profileIdentifiers: [{ profileType: this.profileType, profileCode: this.profileCode }],
        from: SALES_HISTORY_FROM,
        markerType: this.mapType,
      };
    }

    if (canHaveProperties) {
      this.mapTypes = this.canHaveProperties ? ['Review', 'CompletedListing', 'ActiveListing'] : ['Review'];
    }
  }
}
